import { Link } from 'react-router-dom';
import { PropTypes } from 'prop-types';
import { useSelector } from 'react-redux';
import React from 'react';

import * as basePropTypes from 'src/constants/propTypes/base';

import ButtonLink from 'src/components/buttons/ButtonLink';
import Header from 'src/components/navigation/Header';
import Logo from 'src/components/images/logos/FaceOnly';

import LinkItem from './LinkItem';
import ProfileIcon from './ProfileIcon';
import Unauthed from './Unauthed';
import styles from './styles.module.scss';

function Desktop(props) {
  const {
    isCloserToSun,
    isUnauthed,
    pathname,
  } = props;

  const showLearnLanguagesLink = useSelector(state => {
    const { profile } = state;
    if (!profile) return false;

    const isAdmin = profile.get('isAdmin');
    if (!isAdmin) return false;

    const givenFreeAccess = profile.get('givenFreeAccess');
    const accountPlan = profile.get('accountPlan');
    const planType = accountPlan && accountPlan.get('planType');
    return givenFreeAccess ||
      ['premium', 'premium_lifetime', 'premium_45_days'].includes(planType);
  });

  return (
    <Header isCloserToSun={ isCloserToSun } noPadding>
      <div className={ styles.Container }>
        <Choose>
          <When condition={ isUnauthed }>
            <Unauthed pathname={ pathname } />
          </When>

          <Otherwise>
            <ul className={ styles.LeftSideContainer }>
              <li className={ styles.Logo }>
                <Link to={ '/' }>
                  <Logo dataAutomatedTest="home-logo-desktop-link" isLeft />
                </Link>
              </li>

              <li>
                <LinkItem
                  isActive={ pathname === '/' }
                  title="Home"
                  to="/"
                />
              </li>

              <li>
                <LinkItem
                  dataAutomatedTest="site-wide-links--stats"
                  isActive={ pathname === '/stats' }
                  title="Your stats"
                  to="/stats"
                />
              </li>

              <li>
                <LinkItem
                  dataAutomatedTest="site-wide-links--questions"
                  isActive={ pathname === '/questions' }
                  title="Your questions"
                  to="/questions"
                />
              </li>

              <li>
                <LinkItem
                  dataAutomatedTest="site-wide-links--study-sets"
                  isActive={ pathname === '/study-sets' }
                  title="Your study sets"
                  to="/study-sets"
                />
              </li>

              <li>
                <LinkItem
                  isActive={ pathname === '/public-study-sets' }
                  title="Public study sets"
                  to="/public-study-sets"
                />
              </li>

              <If condition={ showLearnLanguagesLink }>
                <li>
                  <LinkItem
                    dataAutomatedTest="site-wide-links--learn-languages"
                    isActive={ pathname === '/featured-collections' }
                    title="Learn Languages"
                    to="/featured-collections"
                  />
                </li>
              </If>
            </ul>

            <ul className={ styles.RightSideContainer }>
              <li className={ styles.AddQuestionContainer }>
                <ButtonLink
                  floatRight
                  isInHeader
                  isSecondary
                  text="Add study set"
                  to="/study-sets/new"
                  withPlusSign
                />
              </li>

              <li className={ styles.ProfileIcon }>
                <div className={ styles.Divider }>|</div>

                <Link to={ '/profile' }>
                  <ProfileIcon isActive={ pathname.includes('/profile') } />
                </Link>
              </li>
            </ul>
          </Otherwise>
        </Choose>
      </div>
    </Header>
  );
}

Desktop.propTypes = {
  isCloserToSun : PropTypes.bool,
  isUnauthed    : PropTypes.bool,
  pathname      : basePropTypes.pathname.isRequired,
};

export default Desktop;
